import { IAssessment, IDueDeliganceAssessment, IBudgetAssessment, IApplicationSection } from '@/entities';
import { IGetters } from './getters.types';

export const getters: IGetters = {
    rootTemplate (state: IAssessment): any {
        if (state.templateList) {
            return state.templateList[state.language] || {}
        } else {
            return {}
        }
    },
    /** get the Due Deligance Assessment (schema | data | selected menu) */
    dueDeliganceAssessment(state: IAssessment): IDueDeliganceAssessment {
        return state.dueDeliganceAssessment;
    },
    /** get the budget assessment (schema | data ) */
    budgetAssessment(state: IAssessment): IBudgetAssessment {
        return state.budgetAssessment;
    },

    /** get application data for peek view */
    appSection(state: IAssessment): IApplicationSection {
        return state.applicationSection.data;
    },
    
    /** get application template for peek view */
    appSectionTemplate(state: IAssessment): any {
        return state.applicationSection.templates[state.language] || {};
    }
}